import React, { Fragment, useEffect, useState } from "react";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { Divider, Grid, InputAdornment, TextField } from "@mui/material";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";

const SearchBar = ({ 
  placeholder, 
  handleSearch,
  selected,
  handleArchiveToggle,
  handleGetLink,
  handleSendLink,
}) => {
  const [archiveOptions, setArchiveOptions] = useState(false);
  const [linkOptions, setLinkOptions] = useState(false);

  const anyActive = archiveOptions || linkOptions;

  useEffect(() => {
    if (selected && selected.length < 1) {
      setArchiveOptions(false);
      setLinkOptions(false);
    }
  }, [selected]);

  const fadeStyle = (isActive) => ({
    opacity: anyActive && !isActive ? 0.3 : 1,
    transition: "opacity 0.2s ease",
  });

  return (
    <Grid container alignItems={"center"}>
      <TextField
        variant="outlined"
        placeholder={placeholder || "Search batch name, status"}
        onChange={handleSearch ? (e) => handleSearch(e) : () => console.log("search")}
        InputProps={{
          sx: { ...searchTextfieldStyles },
          startAdornment: (
            <InputAdornment position="start">
              <SearchOutlinedIcon />
            </InputAdornment>
          ),
        }}
      />
      {selected && selected.length > 0 && (
        <Fragment>
          <span style={selectedItemsStyles}>{selected.length} selected</span>
          <TrendingFlatIcon fontSize="large" style={{ color: "#242424" }} />
          
          <span
            style={{
              ...statusTextStyles,
              color: archiveOptions ? "#9447AF" : "#00A7CD",
              ...fadeStyle(archiveOptions),
            }}
            onClick={() => {
              setArchiveOptions((prev) => !prev);
              setLinkOptions(false);
            }}
          >
            (Un)Archive
          </span>
          {archiveOptions && (
            <Fragment>
              <TrendingFlatIcon
                fontSize="medium"
                style={{ color: "#919191" }}
              />
              <span
                style={statusTextStyles}
                onClick={() => handleArchiveToggle(true)}
              >
                Archive
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextStyles}
                onClick={() => handleArchiveToggle(false)}
              >
                Unarchive
              </span>
            </Fragment>
          )}
        </Fragment>
      )}
    </Grid>
  );
};

export default SearchBar;

const searchTextfieldStyles = {
  height: 40,
  border: "none",
  borderColor: "#7676801F",
  borderRadius: 5,
  width: 270,
  background: "#7676801F",
  color: "#515563",
  fontSize: 14,
  fontWeight: 500,
  paddingLeft: 1,
  paddingRight: 2,
  fontFamily: "Avenir Book, sans-serif",
};

const selectedItemsStyles = {
  color: "#020303",
  marginLeft: 10,
  marginRight: 10,
  fontSize: 14,
  fontWeight: 500,
  fontFamily: "Avenir Book, sans-serif",
};

const statusTextStyles = {
  color: "#00A7CD",
  marginLeft: 10,
  marginRight: 10,
  fontSize: 14,
  fontWeight: 500,
  cursor: "pointer",
  fontFamily: "Avenir Book, sans-serif",
};
